import { useEffect, useState } from 'react'

import { setCommonModal } from '../../../slices/scene/SceneSlice';
import { Stack, Modal, HTMLRenderer, Text, Icon } from "_core/components/common/UI";

import './CommonModal.scss'
import Row from './Row';

const CommonModal = (props) => {
    const [modalInstance, setCommonModalInstance] = useState({ class: '', body: <></> });

    useEffect(() => {
        UpdateModal();
    }, [props.modalInfo.show]);

    // 編集モーダルを開く
	const UpdateModal = () => {
		setCommonModalInstance({
			class: props.modalInfo.show ? 'show' : '',
			body: modalBody()
		});
	};

       //モーダルのボディ
	const modalBody = () => {

        let modalTextElement = "";
        const isString = typeof props.modalInfo.text === 'string';

        if (props.modalInfo.text){
            if (isString) {
                modalTextElement = props.modalInfo.text.replace(/\r\n/g, '\n').replace(/\r/g, '\n').replace(/\r/g, '</br>')
            } else {
                modalTextElement = props.modalInfo.text;
            }
        }

		return(
            <Stack className="common-modal-message spacing-16px padding-16px">
                <Row className="spacing-16px">
                    <Stack className="spacing-8px">
                        {isString ? (
                            <HTMLRenderer htmlContent={modalTextElement}></HTMLRenderer>
                        ) : (
                            modalTextElement
                        )}
                    </Stack>
                </Row>
            </Stack>
		)
	}

    const handleOnclick = () => {
        console.log("クリック処理を実行");

        if (props.modalInfo.onclick)
        {
            props.modalInfo.onclick()
        }
        props.setModalInfo({ show: false, title: "", text: "", onclick: null, oncancel: null, confirmvalue: null, cancelvalue: null});
    }

    const handleOnCancel = () => {
        console.log("キャンセル処理を実行");

        if (props.modalInfo.oncancel) {
            props.modalInfo.oncancel();
        }
        props.setModalInfo({ show: false, title: "", text: "", onclick: null, oncancel: null, confirmvalue: null, cancelvalue: null });
    }

    const closeOnly = () => {
        // oncancel は呼ばず単に閉じる
        props.setModalInfo({ show: false, title: "", text: "", onclick: null, oncancel: null, confirmvalue: null, cancelvalue: null });
    }

    function ShowModal() {
        return (
            <Modal
                className={modalInstance.class}
                dialogclass="modal-dialog-centered"
                name="common-modal"
                title={props.modalInfo.title}

                showClose={!!props.modalInfo.showClose}
                close={() => { closeOnly(); }}
                onBackdropClick={() => closeOnly()}
                
                showCancel={true}
                cancel={() => { handleOnCancel(); }}
                cancelbtnclass="secondary-border"
                cancelvalue={props.modalInfo.cancelvalue ?? "キャンセル"}

                showConfirm={true}
                confirm={() => {handleOnclick()}}
                confirmbtnclass="primary"
                confirmvalue={props.modalInfo.confirmvalue ?? "確認"}
                
                body={modalInstance.body}
            />
        );
    }

    return <ShowModal />
}

export default CommonModal